import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import MainTable from "../components/main-tables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";
import { Button, InputAdornment, TextField } from "@mui/material";
import {
  bank_master_isFirst,
  list_bank_master,
} from "../../redux/sap-master/bank-master";
import { useSelector } from "react-redux";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import {
  sink_bank_isSuccess,
  sink_bank_master,
} from "../../redux/sap-master/brank-master-sink-api";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";
import { useCommonContext } from "../../Utils/commonContext";
const BankMaster = () => {
  const dispatch = useDispatch();
  const bank_master_data = useSelector((state: any) => state.BankMasterListApi);
  const [activePartner, setActivePartner] = React.useState<null | number>(null);
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const [search, setSearch] = useState<string>("");
  const activeData = activeDatas.data;
  const SinkBranchMasterApi = useSelector((State: any) => State.SinkbankMaster);
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();
  // useEffect
  useEffect(() => {
    dispatch(list_bank_master(""));
    if (SinkBranchMasterApi.isSuccess) {
      dispatch(sink_bank_isSuccess(""));
    }
  }, [SinkBranchMasterApi]);

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setActivePartner(null);
    setShowBack(false);
    setTitleContext("Bank Master");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.BankName) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.BankName ?? "Bank Master");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    for (let i = 0; i < bank_master_data.data.result.length; i++) {
      let data = { ...bank_master_data.data.result[i] };
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // create on
      const created_on = new Date(data.created_on);
      // delete data.EffecDate;
      const created_date =
        created_on.getDate() +
        "-" +
        monthNames[created_on.getMonth()] +
        "-" +
        created_on.getFullYear();
      data.created_on
        ? (data.created_on = created_date)
        : console.log("sdfdsf");

      // update on
      const updated_on = new Date(data.updated_on);
      // delete data.EffecDate;
      const update_date =
        updated_on.getDate() +
        "-" +
        monthNames[updated_on.getMonth()] +
        "-" +
        updated_on.getFullYear();
      data.updated_on ? (data.updated_on = update_date) : console.log("sdfdsf");

      filterarr.push(data);
    }
    filterarr.filter((e) => delete e.id);
    // filterarr.filter((e) => delete e.active);
    filterarr.filter((e) => delete e.created_by);
    filterarr.filter((e) => delete e.updated_by);

    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display:
                isMobile && typeof activePartner === "number"
                  ? "none"
                  : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Bank Master
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(sink_bank_master(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (bank_master_data.isFirst && key === 0) {
                    dispatch(bank_master_isFirst(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          activePartner === key ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.BankName}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.BankCode}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display:
                isMobile && typeof activePartner !== "number"
                  ? "none"
                  : "initial",
            }}
          >
            {typeof activePartner !== "number" ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One Bank
              </div>
            ) : (
              <div className="scroll_content_container scroll_content_container_2">
                <div className="grid_container">
                  <div className="detail_item">
                    <label className="f4">Bank Name</label>
                    <p>{activeData.BankName ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Bank Code</label>
                    <p>{activeData.BankCode ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Abs Entry</label>
                    <p>{activeData.AbsEntry ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Country Code</label>
                    <p>{activeData.CountryCod ?? "--"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Active</label>
                    <p>{activeData.active ? "active" : "inActive"}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Create On</label>
                    <p>{activeData.created_on}</p>
                  </div>
                  <div className="detail_item">
                    <label className="f4">Update On</label>
                    <p>{activeData.updated_on}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      <div className="partner-details">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={
            bank_master_data.isLoading || SinkBranchMasterApi.isLoading
              ? true
              : false
          }
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
        {/* <div className="title d-flex">
          <h5>Bank Master</h5>
          <div className="ms-auto me-2">
            <FontAwesomeIcon
              onClick={() => {
                dispatch(list_bank_master(""));
              }}
              style={{
                fontSize: "22px",
                cursor: "pointer",
              }}
              icon={["fas", "arrows-rotate"]}
            />
          </div>
        </div> */}
        {bank_master_data.isSuccess ? (
          mainTable()
        ) : (
          <div className="not_found_container">
            <img src={DataNotFound} alt="" />
            No Data Found
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default BankMaster;
